import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
// import { Button } from "@ts-digital/vrc";
import { getName } from "../../../../store/services/tokenFunc";
import Spinner from "../../../general/spinner";
import { getGreetingTime, startDownloadData } from "../../../../libs/utils";
import Item from "./item";
import { useEffect } from "react";
import {
  moveAnswerFile,
  getAnswerDocumentDetail,
  getAnswerDocumentPreview,
  answersConstants
} from "../../../../store/actions/ask/answers";
import { Modal } from "@ts-digital/vrc";
import ModalZoom from "../../../preview/modalZoom";
import { getAnswerAsk } from "../../../../store/actions/ask";
import Feedback from "./feedback";
import { Modal as ModalAntd } from "antd";
import { FormattedMessage } from "react-intl";

const AccountantAnswer = props => { 

  const auth = useSelector(state => state.auth);
  const answer = useSelector(state => state.ask.answer.detail);
  const companies = useSelector(state => state.company.companies);
  const attachment = useSelector(state => state.ask.attachment);
  const isGettingAnswer = useSelector(state => state.ask.answer.isGettingAnswer);
  const main = useSelector(state => state.main);
  const myType = main.myType;

  const dispatch = useDispatch();

  const [values, setValues] = useState({});
  const [emptyValues, setEmptyValues] = useState(false);
  const [modalZoom, setModalZoom] = useState(null);
  const [modalFeedback, setModalFeedback] = useState(false);
  const [docsFeedback, setDocsFeedback] = useState([]);
  const [docsError, setDocsError] = useState([]);
  const [modalWaiting, setModalWaiting] = useState(false);

  useEffect(() => {
    if (answer.items && answer.items.length > 0) {
      let cn = 0;
      let firstValues = {};
      let firstEmptyValues = false;
      if (!answer.completedAt) {
        firstEmptyValues = true;
      }
      answer.items.map(item => {
        cn++;
        if (item.value && item.value !== "") {
          firstValues["askAnswer-item-field_" + cn] =
            item.format === "date" ? moment(item.value) : item.value;
        }
        return null;
      });
      // setLoaded(true);
      setValues(firstValues);
      setEmptyValues(firstEmptyValues);
    }
  }, [answer]);

  const onMove = (documentId, documentName) => {
    if (companies) {
      const documentOwner = companies.find(x => x.uuid === answer.itemId);
      if (documentOwner) {
        dispatch(moveAnswerFile(
          answer.id,
          documentId,
          documentOwner
        )).then(res => {
          dispatch(getAnswerAsk(answer.id)).then(res2 => {
            setModalFeedback(true);
            setDocsFeedback([{ id: documentId, fileName: documentName }]);
          });
        });
      }
    }
  };

  const onPreview = documentId => {
    if (companies) {
      const documentOwner = companies.find(x => x.uuid === answer.itemId);
      if (documentOwner) {
        setModalZoom(documentId);
        dispatch(getAnswerDocumentDetail(answer.id,
          documentId));
        dispatch(getAnswerDocumentPreview(answer.id,
          documentId));
      }
    }
  };

  const moveFile = (
    item, feedbacks, i, cn, documentOwner
  ) => {
    return new Promise(function(resolve, reject) {
      dispatch(moveAnswerFile(
        answer.id,
        item.value[i].id,
        documentOwner
      ))
        .then(res => {
          if (cn === item.value.length) {
            setDocsFeedback(feedbacks);
            dispatch(getAnswerAsk(answer.id));
            setModalWaiting(false);
            setModalFeedback(true);
          }
          resolve();
        })
        .catch(err => {
          setDocsError(docsError.concat([
            {
              id: item.value[i].id,
              fileName: item.value[i].fileName,
              error: err
            }
          ]));
          if (cn === item.value.length) {
            setDocsFeedback(feedbacks);
            dispatch(getAnswerAsk(answer.id));
            setModalWaiting(false);
            setModalFeedback(true);
          }
          reject();
        });
    });
  };

  async function moveAll(item) {
    if (companies) {
      setModalWaiting(true);
      const documentOwner = companies.find(x => x.uuid === answer.itemId);
      let feedbacks = [];
      let cn = 0;
      for (let i = 0; i < item.value.length; i++) {
        cn++;
        if (item.value[i].source === "dms") {
          feedbacks.push({
            id: item.value[i].id,
            fileName: item.value[i].fileName
          });
          await moveFile(
            item, feedbacks, i, cn, documentOwner
          );
        } else {
          if (cn === item.value.length) {
            setDocsFeedback(feedbacks);
            dispatch(getAnswerAsk(answer.id));
            setModalWaiting(false);
            setModalFeedback(true);
          }
        }
      }
    }
  }

  function renderItems() {
    let items = [];
    let cn = 0;
    if (answer.items) {
      answer.items.map(item => {
        cn++;
        return items.push(<Item
          onMove={(documentId, documentName) =>
            onMove(documentId, documentName)
          }
          onPreview={documentId => onPreview(documentId)}
          myType={myType}
          cn={cn}
          item={item}
          values={values}
          emptyValues={emptyValues}          
          moveAll={() => moveAll(item)}
        />);
      });
    }
    return items;
  }

  const downloadDoc = () => {
    if (attachment.document && attachment.document.content) {
      startDownloadData({
        content: attachment.document.content,
        filename: attachment.document.fileName
      });
    }
  };

  const addPageModalZoom = () => {};

  const onModalZoomClose = () => {
    dispatch({ type: answersConstants.CLEAR_ANSWER_ATTACHMENT });
  };

  const renderModalWaiting = () => {
    return (
      <ModalAntd
        centered
        maskStyle={{ zIndex: 999999 }}
        wrapClassName={"askReader-waiting-modal-wrap"}
        visible={modalWaiting}
        maskClosable={false}
        closable={false}
        footer={null}
      >
        <FormattedMessage id="generic.operation1" /> <FormattedMessage id="generic.operation2" />
      </ModalAntd>
    );
  };

  const renderModalZoom = () => {
    return (
      <Modal
        visible={modalZoom}
        title={<FormattedMessage id="documents.preview.previewDoc" />}
        onClose={e => {
          onModalZoomClose();
          setModalZoom();
          // setModalZoomImg();
          // setModalZoomPage();
          document.getElementsByTagName("body")[0].style.overflow = "auto";
        }}
        type="primary"
        outsideClosable={false}
      >
        <ModalZoom
          downloadDocument={downloadDoc}
          imgSrc={
            attachment && attachment.preview
              ? `data:image/jpeg;base64,${attachment.preview}`
              : null
          }
          onClose={() => {
            setModalZoom();
            // setModalZoomImg();
            // setModalZoomPage();
            onModalZoomClose();
          }}
          openPreviewPage={addPageModalZoom}
          // pagesTotal={totalPages}
          isLoading={attachment.isGettingPreview}
          waitForLoading={true}
          transparentBackground={true}
        />
      </Modal>
    );
  };

  return (
    <div>
      <div className="askAnswer-root">
        {isGettingAnswer && (
          <Spinner
            size="large"
            tip={
              <span>
                <FormattedMessage id="generic.loading1" /> <br /> <FormattedMessage id="generic.loading2" />
              </span>
            }
          />
        )}
        {modalZoom && renderModalZoom()}
        {modalWaiting && renderModalWaiting()}
        {modalFeedback && (
          <Feedback
            
            onClose={() => setModalFeedback(false)}
            docs={docsFeedback}
          />
        )}
        <div className="askAnswer-root-body">
          <div className="askAnswer-title">{answer && answer.title}</div>
          <div className="askAnswer-body-dates">
            <div className="askAnswer-body-dates-received">
              {answer.createdAt && (
                <div>
                  <FormattedMessage id="ask.pages.answer.createdAt" />{" "}
                  {moment(answer.createdAt).format("DD MMM YYYY HH:MM")}
                </div>
              )}
            </div>
            <div className="askAnswer-body-dates-sent">
              {answer.completedAt && <><FormattedMessage id="ask.pages.answer.completedAt" />{" "}</>}
              {answer.completedAt &&
                moment(answer.completedAt).format("DD MMM YYYY HH:MM")}
            </div>
          </div>
          <div className="askAnswer-body-goodMorning">
            {getGreetingTime(moment())} {getName(auth.loginAuth.securityToken)},
          </div>
          <div className="askAnswer-body-items">{renderItems()}</div>
        </div>
      </div>
      {/* {this.renderDeleteDialog()}
            {this.renderConfirmAbortModal()} */}
    </div>
  );
};

export default AccountantAnswer;
